import enzona from '@/assets/images/pay/enzona.png';
import transfermovil from '@/assets/images/pay/transfermovil1.png';

export const CACHE_KEY_LIST_PAYMENTS = 'payments';
export const CACHE_KEY_PAYMENTS = 'payments-one';
export const CACHE_KEY_ADVANCE_BALANCE = 'user-advance-balance';
export const ROUTE_PATH_PAYMENTS = '/payments/payments';
export const TRANSLATION_PREFIX_PAYMENTS = 'payments';
export const SECURITY_KEY_PAYMENTS = 'PAYMENTS';
export const MODAL_KEY_PAYMENT = 'payment_modal';
export const MODAL_KEY_PREPAID = 'dialog-prepaid_action_dialog';
export const MODAL_INVOICE_DETAIL = 'dialog-modal-invoice-detail';

export const PAYMENT_STATUS = {
  Procesando: 'Procesando',
  Pendiente: 'Pendiente',
  Conveniada: 'Conveniada',
  Pagada: 'Pagado',
  'Pago Parcial': 'Pago Parcial'
};

export const TM_PAYMENT_STATUS = {
  PENDING: 'Pendiente',
  PENDING_REFUNDED: 'Pendiente a Devolución',
  CANCELED: 'Cancelado',
  PAYED: 'Pagado',
  REFUNDED: 'Devuelto',
  FAILED: 'Fallido',
};

export const TM_PAYMENT_STATUS_ENUM = {
  PENDING: 'PENDING',
  PENDING_REFUNDED: 'PENDING_REFUNDED',
  CANCELED: 'CANCELED',
  PAYED: 'PAYED',
  REFUNDED: 'REFUNDED',
  FAILED: 'FAILED',
};

export const PAYMENT_TYPES = {
  ENZONA: 'ENZONA',
  TRANSFERMOVIL: 'TRANSFERMOVIL'
};

export const PAYMENT_STATUS_APPEARANCE = {
  Procesando: { color: 'gray' },
  Conveniada: { color: 'gray' },
  Pendiente: { color: 'red' },
  Pagada: { color: 'green' },
  'Pago Parcial': { color: 'blue'}
};

export const TM_PAYMENT_STATUS_APPEARANCE = {
  PENDING: { color: 'gray' },
  PENDING_REFUNDED: { color: 'orange' },
  CANCELED: { color: 'darkgray' },
  PAYED: { color: 'green' },
  REFUNDED: { color: 'blue' },
  FAILED: { color: 'red' },
};

export const AH_PAYMENTS_ERROR = {
  1: 'Usted no tiene deuda, puede realizar un pago anticipado',
  2: 'Pago efectuado satisfactoriamente',
  3: 'La deuda fue pagada anteriormente',
  4: 'Error al procesar el pago',
  5: 'El ID de cliente no existe',
  6: 'El código de transacción es incorrecto',
  7: 'La deuda solicitada no existe',
  8: 'No puede realizar Pagos Anticipados, existen deudas por pagar',
  9: 'Solo procede el pago parcial para el período',
  10: 'Error al consultar la deuda',
  11: 'El código de transacción ha caducado',
  12: 'Su deuda está conveniada, diríjase a la Oficina Comercial',
  13: 'El importe a pagar no se corresponde con el valor actual',
};

export const PAYMENT_GATEWAYS_ENUM = {
  ENZONA_GATEWAY_TYPE: 'ENZONA_GATEWAY_TYPE',
  TRANSFERMOVIL_GATEWAY_TYPE: 'TRANSFERMOVIL_GATEWAY_TYPE',
  // COME2PAY_GATEWAY_TYPE: 'COME2PAY_GATEWAY_TYPE',
};

export const PAYMENT = {
  [PAYMENT_GATEWAYS_ENUM.ENZONA_GATEWAY_TYPE]: {logo: enzona, width: 40, height: 40},
  [PAYMENT_GATEWAYS_ENUM.TRANSFERMOVIL_GATEWAY_TYPE]: {logo: transfermovil, width: 40, height: 40},
};
